export default __webpack_public_path__ + "static/media/Medical.42414a50.jpg";